import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const ppeDetectionExample: TemplateDefinition = {
  mode: "compose",
  slug: "ppe-detection-example",
  version: 1,
  title: "Construction",
  description: "Evaluate policy compliance",
  thumbnailUuid: BASE_ASSETS.ppeDetectionExample.uuid,
  assets: [BASE_ASSETS.ppeDetectionExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.ppeDetectionExample.uuid,
              extension: BASE_ASSETS.ppeDetectionExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value:
            "Please identify the following: helmets, gloves, closed-toe shoes, protective eyewear. If any are missing, please alert me and call out what's missing.",
        },
      },
    ],
    outputAnnotations: false,
    variables: {},
    annotationFormat: "box",
    enableThinking: false,
  } satisfies DocumentInputContentV1,
};
